import logUtil from 'utils/log'
/* eslint-disable camelcase */
import shouldShowFullSizeConversionVariantSelector from 'modules/product/redux/selectors/should-show-full-size-conversion'
import needsToBeRatedProductSelector from 'modules/product/redux/selectors/needs-to-be-rated'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'
import isMakeUpProductVariantUtil from 'modules/product-variant/utils/is-make-up'
import isFoundationOrConcealerFoundationProductVariantUtil from 'modules/product-variant/utils/is-foundation-or-concealer'
import hasEmailCustomerUtil from 'utils/customer/has-email'
import getAllVariantsProductVariantUtil from 'modules/product-variant/utils/get-all-variants'
import isAvailableRawProductVariantUtil from 'modules/product-variant/utils/is-available-raw'
import getQuickShadeVariantsProductVariantUtil from 'modules/product-variant/utils/get-quick-shade-variants'

const MAX_SHADES_COUNT_THRESHOLD = 6
const MIN_SHADES_COUNT_THRESHOLD = 1

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @param {boolean} isExtraExtraSmallScreen
 * @param {State} state
 * @returns {boolean}
 */
const shouldShowQuickShadesProductVariantSelectorUtil = ({
  featuredProductVariant,
  state,
  isExtraExtraSmallScreen
}) => {
  const shouldShowFullSizeConversion = (
    shouldShowFullSizeConversionVariantSelector({ productVariant: featuredProductVariant })(state)
  )
  const shouldLog = featuredProductVariant?.product_id === 8678202409180
  if (shouldShowFullSizeConversion) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] shouldShowFullSizeConversion=true featuredProductVariant=', featuredProductVariant)
    return false
  }

  const productId = featuredProductVariant?.product_id
  // Don't show quick shades
  // if the sampled data is not loaded yet
  const hasSampledObj = getHasSampledProductDataSelector(productId)(state)
  if (
    hasEmailCustomerUtil() &&
    !hasSampledObj
  ) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] no hasSampledObj featuredProductVariant=', featuredProductVariant)
    return false
  }

  const needsToBeRated = (
    needsToBeRatedProductSelector(productId)(state) &&
    !isFullSizeVariantUtil(featuredProductVariant)
  )
  if (needsToBeRated) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] needs to be rated featuredProductVariant=', featuredProductVariant)
    return false
  }

  if (!isMakeUpProductVariantUtil({ featuredProductVariant })) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] not make up featuredProductVariant=', featuredProductVariant)
    return false
  }

  const allVariants = getAllVariantsProductVariantUtil(featuredProductVariant)
  const allVariantsCount = allVariants.length
  if (
    isFoundationOrConcealerFoundationProductVariantUtil({ featuredProductVariant }) &&
    allVariantsCount > MAX_SHADES_COUNT_THRESHOLD
  ) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] foundation or concealer and has > 6 shades featuredProductVariant=', featuredProductVariant)
    return false
  }

  if (allVariantsCount <= MIN_SHADES_COUNT_THRESHOLD) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] not enough shades to show featuredProductVariant=', featuredProductVariant)
    return false
  }

  const {
    /**
     * @type {ProductVariantCollection[]|*}
     */
    quickShadeVariants
  } = getQuickShadeVariantsProductVariantUtil({
    featuredProductVariant,
    isExtraExtraSmallScreen
  })
  const hasVariantInStock = quickShadeVariants.some(isAvailableRawProductVariantUtil)
  if (!hasVariantInStock) {
    shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[noop] no available variants featuredProductVariant=', featuredProductVariant)
    return false
  }

  shouldLog && logUtil('shouldShowQuickShadesProductVariantSelectorUtil').debug('[done] show featuredProductVariant=', featuredProductVariant)
  return true
}

export default shouldShowQuickShadesProductVariantSelectorUtil
